module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_11_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-horni_11_before_tn.jpg
// module id = 1624
// module chunks = 0